import React, { useState } from 'react';
import './styles.css';
import FlashcardCard from './FlashcardCard';
import FlashcardNavigation from './FlashcardNavigation';

const Flashcard = ({ cards }) => {
  const [currentCardIndex, setCurrentCardIndex] = useState(0);
  const [flipped, setFlipped] = useState(false);

  const currentCard = cards[currentCardIndex];

  const flipCard = () => {
    setFlipped(!flipped);
  };

  const goToNextCard = () => {
    if (currentCardIndex < cards.length - 1) {
      setCurrentCardIndex(currentCardIndex + 1);
      setFlipped(false);
    }
  };

  const goToPreviousCard = () => {
    if (currentCardIndex > 0) {
      setCurrentCardIndex(currentCardIndex - 1);
      setFlipped(false);
    }
  };

  return (
    <div className="flashcard">
      <FlashcardCard currentCard={currentCard} flipped={flipped} flipCard={flipCard} />
      <FlashcardNavigation
        currentCardIndex={currentCardIndex}
        cards={cards}
        goToPreviousCard={goToPreviousCard}
        goToNextCard={goToNextCard}
      />
    </div>
  );
};

export default Flashcard;
